<template>
    <div id="funcionario-cadastro">
        <my-tour :steps="steps" name="steps-produtos-cadastro"></my-tour>
        <section id="content">
            <!--start container-->
            <div class="container">
                <TituloPagina titulo="Cadastro de produto" />
                <div class="row">
                    <div class="col s12 m12 l12">
                        <div class="card-panel">
                            <div class="row">
                                <form class="col s12" v-on:submit.prevent="save">
                                    <formulario-produto @newdata="handleDataProduto($event)"></formulario-produto>
                                    <div class="row">
                                        <div class="input-field col s12">
                                            <button class="btn btn-default waves-effect waves-light right salvar-produto-btn" type="submit" name="action">
                                                Salvar
                                                <!-- <i class="material-icons right">send</i> -->
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--end container-->
        </section>
    </div>
</template>
<style>
    .selected {
        color: rgb(0, 188, 212);
        opacity: 1;
    }
    .material-icons.selectable {
        opacity: 0.5;
        cursor: pointer;
    }
</style>
<script>
    import { post } from '@/helpers/api';
    import FormularioProduto from './Formulario';
    import Message from '@/helpers/message';
    import TituloPagina from '@/components/common/TituloPagina';

    import MyTour from '@/components/common/MyTour.vue';
    import Auth from '@/store/auth';
    import { DONO, GERENTE, CORRETOR, ESPECIALISTA, LIDER, MASTER, PARCEIRO } from '@/constants/funcionarioCargo.js';
    import TourHelper from '@/helpers/tour';

    export default {
        components: {
            FormularioProduto,
            TituloPagina,
            MyTour
        },
        data: () => ({
            formData: {
                produto_nome: '',
                produto_descricao: '',
                produto_diferenciais: '',
                produto_icone: '',
                produto_obrigatorio: false,
                categoria_id: null,
            },
             steps: [
                {
                    parent: '#formCampos',
                    target: '#formCampos',
                    content: 'Para isso, basta preencher as informações do produto',
                    params: { cargos: [DONO, PARCEIRO, GERENTE, CORRETOR, ESPECIALISTA, LIDER],
                        placement: 'bottom',
                        menu: false
                    }
                },
                {
                    parent: '#formIcones',
                    target: '#formIcones',
                    content: 'e escolher o item que fica mais fácil de identificá-lo!',
                    params: { cargos: [DONO, PARCEIRO, GERENTE, CORRETOR, ESPECIALISTA, LIDER],
                        placement: 'top',
                        menu: false
                    }
                },
                {
                    parent: '.salvar-produto-btn',
                    target: '.salvar-produto-btn',
                    content: 'E clicar em salvar!',
                    params: { cargos: [DONO, PARCEIRO, GERENTE, CORRETOR, ESPECIALISTA, LIDER],
                        placement: 'left',
                        menu: false
                    }
                },
                {
                    parent: '#left-sidebar-nav',
                    target: '#ajuda',
                    content: 'Caso queira rever este tutorial, você pode clicar clicar em <b>Ajuda</b>, lá terá um botão para reiniciar o tour e a descrição dos itens que são abordados nele! Até breve!',
                    params: { cargos: [DONO, PARCEIRO, GERENTE, CORRETOR, ESPECIALISTA, LIDER],
                        placement: 'left',
                        menu: true,
                        route: '/',
                        subMenu: false,
                    }
                },
                {
                    parent: '',
                    target: '',
                    content: '',
                    params: { cargos: [PARCEIRO, GERENTE, CORRETOR, ESPECIALISTA, LIDER],
                        placement: 'left',
                        menu: false,
                        // route: '/gerenciamento-leads'
                    }
                },

                ],
        }),
        created(){
            // verifica se pode acessar componente
            if (Auth.getCargoUsuario() !== MASTER && [DONO].indexOf(Auth.getCargoUsuario()) === -1) {
                this.$router.push('/sempermissao');
            }
            this.steps = TourHelper.createSteps(this.steps);
        },
        methods: {
            save() {
                if (this.formData.produto_nome === '' ||
                    this.formData.produto_descricao === '' ||
                    // this.formData.produto_diferenciais === '' ||
                    this.formData.produto_icone === '') {
                    Message.messageError('Ícone e Descrição são obrigatórios!');
                    return;
                }

                let self = this;
                post('produto', {
                    produto_nome: this.formData.produto_nome,
                    produto_descricao: this.formData.produto_descricao,
                    produto_diferenciais: this.formData.produto_diferenciais,
                    produto_icone: this.formData.produto_icone,
                    produto_obrigatorio: this.formData.produto_obrigatorio,
                    categoria_id: this.formData.categoria_id,
                }).then(function (response) {
                    Message.messageSuccess(response.data.statusMessage);
                    self.$router.push('/produtos', function () {});
                }).catch(function () {
                    Message.messageError('Ocorreu algum erro, tente novamente mais tarde.');
                });
            },
            handleDataProduto(e) {
                [
                    this.formData.produto_nome,
                    this.formData.produto_descricao,
                    this.formData.produto_diferenciais,
                    this.formData.produto_icone,
                    this.formData.produto_obrigatorio,
                    this.formData.categoria_id,
                ] = e;
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/produtos/Cadastro.vue